import type { LucideIcon } from 'lucide-react';
import { subcategoryIcon } from '../constants/taxonomy';

export function SubcategoryIcon({ name, l1, icon, className = 'w-4 h-4 text-gold' }: {
  name?: string | null; l1?: string; icon?: LucideIcon; className?: string;
}) {
  const Icon = icon ?? subcategoryIcon(name, l1);
  return <Icon className={className} aria-hidden="true" strokeWidth={1.7} />;
}
